export class ErrorDialogData {
  title: string;
  errors: string[];
}
